import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getPolicies } from "../../store/actions/councilActions/policyAction";
import BreadCrumb from "../BreadCrumb";
import "./policy.css";

// Website: all active policies, grouped by the trade they belong to.
export default function Policies() {
  const dispatch = useDispatch();
  const [list, setList] = useState(null);

  useEffect(() => {
    dispatch(getPolicies()).then(setList);
  }, [dispatch]);

  const groups = {};
  (list || []).forEach((p) => {
    const key = p.trade?.name || "General";
    (groups[key] = groups[key] || []).push(p);
  });

  const breadcrumbs = [{ path: "/", label: "Home" }, { label: "Policies" }];

  return (
    <div class="lists-box">
      <div class="container">
        <BreadCrumb crumbs={breadcrumbs} />
        <div class="title-box">
          <h4>Policies</h4>
        </div>

        {list === null ? (
          <div class="text-center my-5">
            <Spinner animation="border" />
          </div>
        ) : list.length === 0 ? (
          <p class="my-5 text-center">No policies have been added yet.</p>
        ) : (
          <div class="policy-groups">
            {Object.keys(groups).map((trade) => (
              <div class="policy-group" key={trade}>
                <h5 class="policy-group-title">{trade}</h5>
                <div class="policy-list">
                  {groups[trade].map((p) => (
                    <Link
                      class="policy-item"
                      to={`/policies/${p.slug}`}
                      key={p.id}
                    >
                      <span class="policy-item-title">{p.title}</span>
                      <span class="policy-item-arrow">&#10095;</span>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
